import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Porcentaje sindicato"),
  /*#__PURE__*/_createElementVNode("th", null, "Deducción sindicato"),
  /*#__PURE__*/_createElementVNode("th", null, "Sanción pública"),
  /*#__PURE__*/_createElementVNode("th", null, "Sanción privada"),
  /*#__PURE__*/_createElementVNode("th", null, "Pago tercero"),
  /*#__PURE__*/_createElementVNode("th", null, "Anticipo")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = { class: "tooltip-container" }
const _hoisted_9 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.LaborUnionPercentage.$error }]),
            onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.LaborUnionPercentage.$touch())),
            modelValue: $setup.sspta.LaborUnions[0].Percentage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.sspta.LaborUnions[0].Percentage) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.LaborUnionTotal.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.LaborUnionTotal.$touch())),
            modelValue: $setup.sspta.LaborUnions[0].Total,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.sspta.LaborUnions[0].Total) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.SanctionPublicTotal.$error }]),
            onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.SanctionPublicTotal.$touch())),
            modelValue: $setup.sspta.Sanctions[0].PublicTotal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.sspta.Sanctions[0].PublicTotal) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SanctionPrivateTotal.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.v$.SanctionPrivateTotal.$touch())),
            modelValue: $setup.sspta.Sanctions[0].PrivateTotal,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.sspta.Sanctions[0].PrivateTotal) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.ThirdPartyPaymentDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[8] || (_cache[8] = ($event: any) => ($setup.v$.ThirdPartyPaymentDeduction.$touch())),
            modelValue: $setup.sspta.ThirdPartyPaymentDeductions[0],
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.sspta.ThirdPartyPaymentDeductions[0]) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PrepaidDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[10] || (_cache[10] = ($event: any) => ($setup.v$.PrepaidDeduction.$touch())),
            modelValue: $setup.sspta.PrepaidDeductions[0],
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.sspta.PrepaidDeductions[0]) = $event))
          }, null, 8, ["modelValue", "class"])
        ])
      ]),
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.LaborUnionPercentage.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.LaborUnionPercentage.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.LaborUnionTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.LaborUnionTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SanctionPublicTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SanctionPublicTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SanctionPrivateTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SanctionPrivateTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.ThirdPartyPaymentDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.ThirdPartyPaymentDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PrepaidDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.PrepaidDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}